import { Institution } from "./institution.model";


export class ImportInstitutionViewModel {
   constructor(public institutions: Institution[]) {}
}

